export default {"src":"/newStatic/_next/static/media/hardWallet_icon.542e0f9d.svg","height":49,"width":48};